import {
  AbstractType,
  ChangeDetectionStrategy,
  Component,
  InjectionToken,
  Injector,
  Input,
  Type,
  ViewEncapsulation,
} from '@angular/core';
import {
  IDocumentErrorMessage,
  IDocumentInfoErrorType,
  IDocumentInfoMessage,
} from '@shared/types/ui/components';
import { map, isEmpty, isFunction } from 'lodash';
import { cloneDataWithDepth } from '@shared/utils';
import { I18n } from '@app/i18n/strings-keys';
import { lazyInject } from '@app/containers/base/decorators';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'xux-document-info-error-message',
  templateUrl: 'xux-document-info-error-message.component.html',
  styleUrls: ['xux-document-info-error-message.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XuxDocumentInfoErrorMessageComponent {
  @lazyInject(TranslateService)
  public translateService: TranslateService;

  public I18n = I18n;

  public componentMessageData: (IDocumentInfoMessage | IDocumentErrorMessage)[];

  @Input('messageData') public set componentMessageDataFromOrigin(
    messageData: (IDocumentInfoMessage | IDocumentErrorMessage)[],
  ) {
    this.componentMessageData = map(
      cloneDataWithDepth(messageData),
      (message) => {
        if (isEmpty(message?.errors)) return message;

        return {
          ...message,
          errors: map(message.errors, (error) => ({
            ...error,
            showOrigin: false,
          })),
        };
      },
    );
  }

  public constructor(public injector: Injector) {}

  public inject<T>(
    token: Type<T> | InjectionToken<T> | AbstractType<T>,
    notFoundValue?: T,
  ): T {
    if (isFunction(this.injector.get)) {
      return this.injector?.get(token, notFoundValue);
    }

    return notFoundValue;
  }

  public showMoreButtonHandler(error: IDocumentInfoErrorType): void {
    error.showOrigin = !error.showOrigin;
  }

  public getShowDetailsText(error: IDocumentInfoErrorType): string {
    return this.translateService
      .instant(I18n.InfoMessages.ShowHowManyDetails)
      .translate({
        howMany: this.translateService.instant(
          error.showOrigin ? this.I18n.Common.Less : this.I18n.Common.More,
        ),
      })
      .toString();
  }
}
